import _dev from './_dev';
import general from './general';
import products from './products';
import church from './church';
import restaurant from './restaurant';
import blog from './blog';
import serviceCompany from './service-company';
import profiles from './profiles';
import places from './places';
import media from './media';
// we use this to tell the editor what droplets to load
// per what type of site it is
export default {
  dev: _dev(),
  general: general(),
  church: church(),
  restaurant: restaurant(),
  products: products(),
  blog: blog(),
  serviceCompany: serviceCompany(),
  profiles: profiles(),
  places: places(),
  media: media(),
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/index.js